module.exports = __webpack_public_path__ + "img/pre-500.ff8c7164.jpg";